// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.story-correct-word {
  flex: 0 1;
  background-color: rgb(203, 231, 255);
  padding: 10px;
  border-radius: 10px;
}

.story-correct-word.long{
  font-size: .8em;
}`, "",{"version":3,"sources":["webpack://./src/Components/Games/Newsie/UploadContentNewsie/NewsiePreview/CorrectWord/CorrectWord.css"],"names":[],"mappings":"AAAA;EACE,SAAO;EACP,oCAAoC;EACpC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".story-correct-word {\n  flex: 0;\n  background-color: rgb(203, 231, 255);\n  padding: 10px;\n  border-radius: 10px;\n}\n\n.story-correct-word.long{\n  font-size: .8em;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
